<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="start">
      <!-- <el-col :span="8" class="flex">
        <span style="flex-shrink: 0"> 账户名 </span>
        <el-input
          v-model="search.accountName"
          placeholder="请输入账户名"
          clearable
        ></el-input>
      </el-col> -->
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0"> 姓名 </span>
        <el-input
          v-model="search.name"
          placeholder="请输入姓名"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span> 所属组织 </span>
        <BelongOrgSelect v-model="search.organization"></BelongOrgSelect>
      </el-col>
      <el-col :span="8" class="flex">
        <span>状态</span>
        <el-select v-model="search.state" placeholder="请选择状态" clearable>
          <el-option
            v-for="(val, key) in statusEnum"
            :key="key"
            :label="val"
            :value="key"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="start">
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0"> 身份证 </span>
        <el-input
          v-model="search.idNumber"
          placeholder="请输入身份证"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0"> 联系方式 </span>
        <el-input
          v-model="search.phone"
          :maxlength="11"
          placeholder="请输入联系方式"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0"> 回收品类 </span>
        <el-select v-model="search.spids" placeholder="请选择承接品类">
          <el-option
            v-for="item in acceptedCategoriesList"
            :key="item.spid"
            :label="item.spmc"
            :value="item.spid"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="start">
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">省份</span>
        <el-select
          v-model="search.provinceCode"
          placeholder="请选择省份"
          clearable
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">市</span>

        <el-select
          v-model="search.cityCode"
          placeholder="请选择市"
          clearable
          :disabled="!search.provinceCode"
          @change="getTblDistrict"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">区</span>
        <el-select
          v-model="search.districtCode"
          placeholder="请选择区域"
          clearable
          :disabled="!search.cityCode"
        >

        <el-option
          v-for="item in districtList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          style="width: 100%"
        >
        </el-option>
      </el-select>
      </el-col>
    </el-row>

    <el-row type="flex" class="row-bg" justify="start">
      <el-col :span="5" class="">
        <el-button type="primary" size="medium" @click="searchDataBtnFun"
          >查询</el-button
        >
        <el-button size="medium" @click="resetForm">重置</el-button>
      </el-col>
    </el-row>
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="addMasterFun"
        >创建回收人员</el-button
      >
      <!-- <el-button type="primary" size="medium" @click="batchAddMasterFun"
        >批量创建回收人员</el-button
      > -->
    </div>
    <el-tabs v-model="tabActiveName" @tab-click="handleTabClick">
      <el-tab-pane label="已审核" name="已审核"></el-tab-pane>
      <el-tab-pane label="待审核" name="待审核"></el-tab-pane>
    </el-tabs>

    <el-table
      ref="checktableData"
      :data="tableDataList"
      v-loading="tableDataLoading"
      height="60vh"
    >
      <el-table-column type="selection" min-width="50" align="center">
      </el-table-column>
      <el-table-column
        prop="id"
        label="回收人员编号"
        min-width="80"
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="account"
        label="账户名"
        min-width="120"
        align="center"
      ></el-table-column> -->
      <el-table-column
        prop="name"
        label="姓名"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="idNumber"
        label="身份证"
        min-width="160"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="联系方式"
        min-width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="organization"
        label="所属组织"
        min-width="140"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ organizationMap[scope.row.organization] }}</span>
        </template>
      </el-table-column>
      <template>
        <el-table-column
          prop=""
          label="回收区域"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ filterAddress(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="回收品类"
          min-width="140"
          align="center"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.splbDaleiList && scope.row.splbDaleiList.length"
          >
            <span v-for="item in scope.row.splbDaleiList" :key="item.spid">
              {{ item.spmc }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="cooperationTypeStr" label="合作类型" min-width="240" align="center"></el-table-column> -->
        <el-table-column
          prop=""
          label="高空作业证"
          min-width="240"
          align="center"
        >
          <template slot-scope="scope" v-if="scope.row.highWorkPermit">
            <div class="highWorkPermit">
              <image-upload
                v-for="(item, index) in scope.row.highWorkPermit.split(',')"
                :key="index"
                :imageUrl="item"
                :editMode="false"
                :appendToBody="true"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="保险凭证"
          min-width="240"
          align="center"
        >
          <template slot-scope="scope" v-if="scope.row.insuranceImage">
            <div class="highWorkPermit">
              <image-upload
                v-for="(item, index) in scope.row.insuranceImage.split(',')"
                :key="index"
                :imageUrl="item"
                :editMode="false"
                :appendToBody="true"
              />
            </div>
          </template>
        </el-table-column>
      </template>

      <el-table-column prop="state" label="状态" min-width="100" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stateStr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state == 2"
            type="text"
            @click="editRowFun(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.state !== 0 && tabActiveName == '已审核'"
            type="text"
            @click="disabledOrOpenRowFun(scope.row)"
            >{{ scope.row.state == 1 ? "禁用" : "启用" }}</el-button
          >
          <el-button
            v-if="scope.row.state !== 0 && tabActiveName == '已审核'"
            type="text"
            @click="deleteRowFun(scope.row)"
            >删除</el-button
          >
          <el-button
            v-if="tabActiveName == '待审核' && scope.row.approved"
            type="text"
            @click="handleAgree(scope.row.id)"
            >同意</el-button
          >
          <el-button
            v-if="tabActiveName == '待审核' && scope.row.approved"
            type="text"
            @click="$refs.masterRejectRef.openDialog(scope.row.id)"
            >驳回修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.pageNum"
        :page-size.sync="search.pageSize"
        :page-sizes="[10, 20]"
        :total="tableDataTotalNum"
      >
      </el-pagination>
    </div>
    <AddOrEditMasterDialog
      ref="AddOrEditMasterDialogRef"
      @opera-success="getList"
    ></AddOrEditMasterDialog>
    <BatchAddMasterVue
      ref="batchAddMasterRef"
      @opera-success="getList"
    ></BatchAddMasterVue>
    <MasterReject ref="masterRejectRef" @opera-success="getList">
    </MasterReject>
  </div>
</template>
<script>
import BelongOrgSelect from "@/components/BelongOrgSelect";
import AddOrEditMasterDialog from "./components/AddOrEditMasterDialog";
import BatchAddMasterVue from "./components/BatchAddMaster.vue";
import MasterReject from "./components/MasterReject.vue";
import imageUpload from "@/components/Upload/ImageUpload";

import {
  approveEngineer,
  getProductType,
  findAllProvince,
  findAllCity,
  findAllDistrict
} from "@/api/masterFile";
export default {
  name: "masterFile",
  components: {
    BelongOrgSelect,
    AddOrEditMasterDialog,
    BatchAddMasterVue,
    MasterReject,
    imageUpload
  },

  data() {
    return {
      /**
       * tableDataLoading 表格数据加载是否完毕
       * tableDataList 表格数据
       * search 表单查询数据
       *    accountName 账户名
       *    name 姓名
       *    organization 所属组织
       *    idNumber 身份证号
       *    phone 联系方式
       *    pageSize 页数量
       *    pageNum 页码
       * tableDataTotalNum 表格数据总数
       * allSelectedIds 所有选中的数据
       * unSelectedIds 所有未选中的id
       */
      tableDataLoading: false,
      tableDataList: [],
      acceptedCategoriesList: [], //品类列表
      provinceList: [], //省份列表
      cityList: [], //市列表
      districtList: [], //区域列表
      search: {
        spids: "", //品类
        accountName: "",
        name: "",
        organization: "",
        idNumber: "",
        phone: "",
        pageSize: 10,
        pageNum: 1,
        approved: true, //true已审核、false未审核
        provinceCode: "", //省
        cityCode: "", //市
        districtCode: "" //区
      },
      tableDataTotalNum: 0,
      allSelectedIds: [],
      unSelectedIds: [],
      // 状态 0 删除 1 有效 2 无效
      statusNum: {
        0: "删除",
        1: "有效",
        2: "无效"
      },
      statusEnum: {
        1: "有效",
        2: "无效",
        3: "待所属单位审核",
        4: "待总公司审核",
        5: "驳回"
      },
      organizationMap: {},
      tabActiveName: "已审核"
    };
  },
  async created() {
    this.getList();
    this.init();
  },
  methods: {
    async init() {
      this.getOrgList();
      this.getProductTypeOption();
      this.getTblProvince();
    },
    handleTabClick(tab, event) {
      this.search.pageNum = 1;
      if (tab.label === "已审核") {
        this.search.approved = true;
      } else if (tab.label === "待审核") {
        this.search.approved = false;
      }
      this.getList();
    },
    filterAddress(row) {
      const { province, city, district } = row;
      return `${province || ""}${city || ""}${district || ""}`.trim() || "";
    },
    //获取回收品类
    async getProductTypeOption() {
      const res = await getProductType();
      if (res.statusCode === 200) {
        this.acceptedCategoriesList = res.data.filter(
          item => item.spid !== 105
        );
      }
    },
    //处理同意
    async handleAgree(id) {
      let _this = this;
      this.$confirm("是否确认同意", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: " warning"
      }).then(() => {
        _this.confirmAgree(id);
      });
    },
    async confirmAgree(id) {
      const params = {
        id: id,
        status: 1
      };
      let { statusCode } = await approveEngineer(params);
      if (statusCode === 200) {
        this.$message.success("操作成功");
        this.getList();
      }
    },
    getOrgList() {
      const url =
        "/autoapp-recovery-server-auth/api/tbl-partner-management/list";
      this.HttpService.post(url, {}).then(res => {
        if (res.statusCode === 200 && res.data.length) {
          this.organizationMap = res.data.reduce((obj, item) => {
            obj[item.partnershipId] = item.partnerName;
            return obj;
          }, {});
        }
      });
    },
    // 查询事件
    searchDataBtnFun() {
      this.search.pageNum = 1;
      this.getList();
    },
    // 获取数据请求
    getList() {
      this.tableDataList = [];
      this.tableDataLoading = true;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/tbl-recycel-engineer/page",
        this.search
      ).then(res => {
        if (res.statusCode === 200) this.tableDataTotalNum = res.total;
        if (res.data.length === 0) {
          this.$dialog({
            title: "温馨提示",
            content: "未查询到结果!",
            footBtn: false,
            width: "20%",
            dialogType: "sighicon"
          });
        } else {
          this.tableDataList = res.data.records;
          this.tableDataLoading = false;
        }
      });
    },
    // 页数改变
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList();
    },
    // 页码改变
    handleCurrentChange() {
      this.getList();
    },
    // 重置查询
    resetForm() {
      this.search = {
        account: "",
        name: "",
        organization: "",
        idNumber: "",
        contactAddress: "",
        pageSize: 10,
        pageNum: 1,
        approved: true
      };
      this.tabActiveName = "已审核";
      this.getList();
    },
    // 创建回收人员
    addMasterFun() {
      this.$refs.AddOrEditMasterDialogRef.openDialog("add");
    },
    // 批量创建回收人员
    batchAddMasterFun() {
      this.$refs.batchAddMasterRef.openDialog();
    },
    // 编辑
    editRowFun(row) {
      this.$refs.AddOrEditMasterDialogRef.openDialog("edit", row);
    },
    // 禁用或者启用 state: 1(有效) | 2(无效)
    disabledOrOpenRowFun(row) {
      const currentState = row.state;
      const params = {
        id: row.id,
        state: currentState == 1 ? 2 : 1
      };
      const url =
        "/autoapp-default-server-recovery/api/tbl-recycel-engineer/save";
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          const msgTip = currentState == 1 ? "禁用成功" : "启用成功";
          this.$message.success(msgTip);
          this.getList();
        } else {
          const tipMsg = res.message || "操作失败";
          this.$message.error(tipMsg);
        }
      });
    },
    // 删除
    deleteRowFun(row) {
      const id = row.id;
      if (id) {
        this.$dialog({
          title: "温馨提示",
          content: "是否要删除，删除后不可以恢复！",
          cancel_buttton: "否",
          ok_buttton: "是",
          width: "400px",
          footBtn: "card",
          dialogType: "delete",
          onOk: () => {
            const idList = [id];
            this.HttpService.delete(
              `/autoapp-default-server-recovery/api/tbl-recycel-engineer/deleteByIds?idList=${idList}`,
              {}
            ).then(res => {
              if (res.statusCode === 200) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                const tipMsg = res.message || "操作失败";
                this.$message.error(tipMsg);
              }
            });
          },
          onCancel: () => {
            console.log("cancel");
          }
        });
      }
    },
    //获取省份列表
    async getTblProvince() {
      this.search.cityCode = "";
      this.search.districtCode = "";

      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.search.cityCode = "";

      if (!this.search.provinceCode) {
        return;
      }
      // const selectedProvince = this.provinceList.find(
      //   item => item.id === this.search.provinceCode
      // );
      // this.search.province = selectedProvince ? selectedProvince.name : ""; // 赋值省份名称

      let { statusCode, data } = await findAllCity(this.search.provinceCode);
      if (statusCode === 200) {
        this.cityList = data;
      }
    },
    //根据省份获取城市列表
    async getTblDistrict() {
      this.search.districtCode = "";
      if (!this.search.cityCode) {
        return;
      }

      // const selectedCity = this.cityList.find(item => item.id === paramsCode);
      // this.search.city = selectedCity ? selectedCity.name : ""; // 赋值城市名称

      let { statusCode, data } = await findAllDistrict(this.search.cityCode);
      if (statusCode === 200) {
        this.districtList = data;
        console.log('ww',data);

      }
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  padding: 0 20px;

  span {
    min-width: 80px;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
.highWorkPermit {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/system/masterFile.vue